import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { RegisterService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  RegisterCreateDto,
  RegisterDto,
  RegisterExcelDownloadDto,
  RegisterUpdateDto,
} from '../proxy/planning/dtos/register';
import { ACTION_IDS, REGISTER_ACTIONS, REGISTER_CONFIG, REGISTER_FIELDS } from './register.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm, IActionsSchema, resolveActions } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-register',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, RegisterService, ConfirmationService],
  templateUrl: './register.html',
  styleUrl: './register.scss',
})
export class Register extends BaseHierarchicalCrudComponent<
  RegisterDto,
  RegisterCreateDto,
  RegisterUpdateDto,
  RegisterExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(RegisterService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('Register', ids),
  };
  config = REGISTER_CONFIG;
  fields = REGISTER_FIELDS;
  actions: IActionsSchema | null = null;

  private readonly triggerMap: Record<number, () => void> = {
    [ACTION_IDS.downloadExcelTemplateTrigger]: () => this.downloadExcelTemplate(),
  };

  override ngOnInit(): void {
    super.ngOnInit();
    this.actions = resolveActions(REGISTER_ACTIONS, this.triggerMap);
  }

  protected prepareUpdateDto(data: any, selected: RegisterDto): RegisterUpdateDto {
    return {
      documentaryArea: data.documentaryArea,
      standArea: data.standArea,
      otherUseArea: data.otherUseArea,
      exoneratedArea: data.exoneratedArea,
      isTaxIncentiveApplied: data.isTaxIncentiveApplied,
      coneatIndex: data.coneatIndex,
      isFscCertified: data.isFscCertified,
      isPefcCertified: data.isPefcCertified,
      officialCertifiedArea: data.officialCertifiedArea,
      description: data.description,
      purchaseDate: data.purchaseDate,
      deedDate: data.deedDate,
      deedValue: data.deedValue,
      policeCadastralSectionId: data.policeCadastralSectionId,
      judicialCadastralSectionId: data.judicialCadastralSectionId,
      ownershipDate: data.ownershipDate,
      propertyId: data.propertyId,
      previousName: data.previousName,
      fscCertificationDate: data.fscCertificationDate,
      fscForestryManagementId: data.fscForestryManagementId,
      pefcCertificationDate: data.pefcCertificationDate,
      pefcForestryManagementId: data.pefcForestryManagementId,
      notes: data.notes,
      fiscalValue: data.fiscalValue,
      dicose: data.dicose,
      exemptsTaxes: data.exemptsTaxes,
      name: data.name,
      departmentId: data.departmentId,
      locationId: data.locationId,
      propertyTypeId: data.propertyTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Register';
  }

  private downloadExcelTemplate() {
    this.service.getRegisterValuesImportTemplate().subscribe({
      next: result => {
        this.toaster.success('LanguageService::Actions:SuccessMessage', '', { life: 5000, messageLocalizationParams: [this.localizationService.instant('LanguageService::Actions:ExcelTemplateDownload')] });
        this.downloadFile(result, 'register-values-template');
      },
      error: error => {
        this.toaster.error(error, '', { life: 5000 });
      },
    });
  }
}
